import React from 'react';
import Hero from '../components/Hero';
import TrustedSection from '../components/TrustedSection';
import HeroFeatures from '../components/HeroFeatures';
import CourseCards from '../components/CourseCards';
import Stats from '../components/Stats';
import DemoLectures from '../components/DemoLectures';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';
import BouncingBadge from '../components/BouncingBadge'; 
import Chatbubble from '../components/chatbubble';

const Home = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handle = () => setIsMobile(mq.matches);
    handle();
    if (mq.addEventListener) mq.addEventListener('change', handle);
    else mq.addListener(handle);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handle);
      else mq.removeListener(handle);
    };
  }, []);

  return (
    <div>
      {!isMobile && <Hero />} 
      {isMobile &&<Chatbubble/>}
      {!isMobile && <TrustedSection /> }
      <HeroFeatures />
      <CourseCards />
      {/* <Stats />  */}
      <DemoLectures />
      {/* <Testimonials /> */}
      <CTA />

      {/* never-stops bouncing badge */}
      <BouncingBadge />
    </div>
  );
};

export default Home;